// extracted by mini-css-extract-plugin
export default {"loginForm":"Login_loginForm__ID-kw","dontHaveAccountLink":"Login_dontHaveAccountLink__bax4z","forgotPasswordLink":"Login_forgotPasswordLink__G8TB9"};